/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as GraphDefs from './defs.defs.js'

const $nsid = 'app.bsky.graph.getListsWithMembership'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  actor: /*#__PURE__*/ l.string({ format: 'at-identifier' }),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 100 }),
      50,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  purposes: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.string<{ knownValues: ['modlist', 'curatelist'] }>(),
    ),
  ),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  listsWithMembership: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<ListWithMembership>((() => listWithMembership) as any),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Enumerates the lists created by the session user, and includes membership information about `actor` in those lists. Only supports curation and moderation lists (no reference lists, used in starter packs). Requires auth. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

/** A list and an optional list item indicating membership of a target user to that list. */
type ListWithMembership = {
  $type?: 'app.bsky.graph.getListsWithMembership#listWithMembership'
  list: GraphDefs.ListView
  listItem?: GraphDefs.ListItemView
}

export type { ListWithMembership }

/** A list and an optional list item indicating membership of a target user to that list. */
const listWithMembership = /*#__PURE__*/ l.typedObject<ListWithMembership>(
  $nsid,
  'listWithMembership',
  /*#__PURE__*/ l.object({
    list: /*#__PURE__*/ l.ref<GraphDefs.ListView>(
      (() => GraphDefs.listView) as any,
    ),
    listItem: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<GraphDefs.ListItemView>(
        (() => GraphDefs.listItemView) as any,
      ),
    ),
  }),
)

export { listWithMembership }
